import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const initSmoothScroll = function(){
	let offset;

	const _init = function(){

		const button = document.getElementById('work-button');
		const section = document.getElementById('recent-work');

		offset = _getOffset(section);

		window.addEventListener('resize', function(){
			offset = _getOffset(section);
		});
		
		button.addEventListener('click', function(){
			// section.scrollIntoView({ behavior: 'smooth' });		
			window.scroll({ top: offset, left: 0, behavior: 'smooth' });
		});
	};

	const _getOffset = function(el){
		const bodyRect = document.body.getBoundingClientRect();
    const elemRect = el.getBoundingClientRect();
    
    return elemRect.top - bodyRect.top;
	}

	return {
		init: _init
	};

}();

if (document.getElementById('recent-work')) {
	initSmoothScroll.init();
}


// WEBPACK FOOTER //
// ./resources/js/partials/SmoothScroll.js